import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Grid } from '@material-ui/core';
import { blackColor } from '../../../assets/jss/nextjs-material-kit-pro';

const styles = makeStyles((theme) => ({
  frame: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  centerTable: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
  },
  leftSide: {
    [theme.breakpoints.up('md')]: {
      maxWidth: '40%',
      margin: '0 45px 0 45px',
    },
    [theme.breakpoints.down('md')]: {
      maxWidth: '100%',
      margin: '0 5px 0 5px',
    },
  },
  rightSide: {
    [theme.breakpoints.up('md')]: {
      maxWidth: '40%',
      margin: '0 45px 0 45px',
    },
    [theme.breakpoints.down('md')]: {
      maxWidth: '100%',
      margin: '0 5px 0 5px',
    },
  },
  bold: {
    fontWeight: 600,
    [theme.breakpoints.up('md')]: {
      fontSize: '1.00rem',
      lineHeight: '1.55rem',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '0.90rem',
      lineHeight: '1.35rem',
    },
  },
  datesText: {
    [theme.breakpoints.up('md')]: {
      fontSize: '1.00rem',
      lineHeight: '1.55rem',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '0.90rem',
      lineHeight: '1.35rem',
    },
  },
  title: {
    fontSize: '1.10rem',
    lineHeight: '1.65rem',
    fontWeight: 700,
    textAlign: 'left',
    margin: '5px 0',
    [theme.breakpoints.up('md')]: {
      padding: '10px 0 15px 0',
    },
    [theme.breakpoints.down('md')]: {
      padding: '5px 0 10px 0',
    },
  },
  link: {
    color: blackColor,
    textDecoration: 'underline',
    fontSize: '1rem',
    fontWeight: 600,
  },
  description: {
    fontSize: '1.00rem',
    fontWeight: 500,
    textAlign: 'left',
    padding: '10px 0 10px 0',
    color: blackColor,
  },
  spacer: {
    padding: '8px 0',
  },
  divider: {
    borderBottom: '2px solid #dcdcdc',
  },
}));

export default function AlumniLinks(props) {
  const classes = styles();

  return (
    <Box className={classes.frame}>
      <Grid container spacing={3} direction="row" className={classes.centerTable}>
        <Grid item xs={12} lg={6} className={classes.leftSide}>
          <section className={classes.title}>Upcoming ACT Test Dates</section>
          <Grid container direction="row" align="left">
            <Grid item xs={4} className={classes.bold}>
              Test Date
            </Grid>
            <Grid item xs={4} className={classes.bold}>
              Registration Deadline
            </Grid>
            <Grid item xs={4} className={classes.bold}>
              Late Fee Required
            </Grid>
          </Grid>
          {new Date() < new Date('2025/06/14') && (
            <Grid container direction="row" align="left">
              <Grid item xs={4} className={classes.datesText}>
                June 14, 2025
              </Grid>
              <Grid item xs={4} className={classes.datesText}>
                May 9
              </Grid>
              <Grid item xs={4} className={classes.datesText}>
                May 26
              </Grid>
            </Grid>
          )}
          {new Date() < new Date('2025/07/12') && (
            <Grid container direction="row" align="left">
              <Grid item xs={4} className={classes.datesText}>
                July 12, 2025
              </Grid>
              <Grid item xs={4} className={classes.datesText}>
                June 6
              </Grid>
              <Grid item xs={4} className={classes.datesText}>
                June 20
              </Grid>
            </Grid>
          )}
          {new Date() < new Date('2025/09/06') && (
            <Grid container direction="row" align="left">
              <Grid item xs={4} className={classes.datesText}>
                September 6, 2025
              </Grid>
              <Grid item xs={4} className={classes.datesText}>
                August 1
              </Grid>
              <Grid item xs={4} className={classes.datesText}>
                August 19
              </Grid>
            </Grid>
          )}
          {new Date() < new Date('2025/10/18') && (
            <Grid container direction="row" align="left">
              <Grid item xs={4} className={classes.datesText}>
                October 18, 2025
              </Grid>
              <Grid item xs={4} className={classes.datesText}>
                September 12
              </Grid>
              <Grid item xs={4} className={classes.datesText}>
                September 30
              </Grid>
            </Grid>
          )}
          {new Date() < new Date('2025/12/13') && (
            <Grid container direction="row" align="left">
              <Grid item xs={4} className={classes.datesText}>
                December 13, 2025
              </Grid>
              <Grid item xs={4} className={classes.datesText}>
                November 7
              </Grid>
              <Grid item xs={4} className={classes.datesText}>
                November 24
              </Grid>
            </Grid>
          )}
          {new Date() < new Date('2026/02/14') && (
            <Grid container direction="row" align="left">
              <Grid item xs={4} className={classes.datesText}>
                February 14, 2026
              </Grid>
              <Grid item xs={4} className={classes.datesText}>
                January 7
              </Grid>
              <Grid item xs={4} className={classes.datesText}>
                January 21
              </Grid>
            </Grid>
          )}
          {new Date() < new Date('2026/04/11') && (
            <Grid container direction="row" align="left">
              <Grid item xs={4} className={classes.datesText}>
                April 11, 2026
              </Grid>
              <Grid item xs={4} className={classes.datesText}>
                March 6
              </Grid>
              <Grid item xs={4} className={classes.datesText}>
                March 24
              </Grid>
            </Grid>
          )}
          {new Date() < new Date('2026/04/11') && (
            <Grid container direction="row" align="left">
              <Grid item xs={4} className={classes.datesText}>
                June 13, 2026
              </Grid>
              <Grid item xs={4} className={classes.datesText}>
                May 8
              </Grid>
              <Grid item xs={4} className={classes.datesText}>
                May 27
              </Grid>
            </Grid>
          )}
          <div className={classes.divider} style={{ marginTop: '30px' }}></div>
        </Grid>
        <Grid item xs={12} lg={6} className={classes.rightSide}>
          <section className={classes.title}>Resources</section>
          <summary style={{ textAlign: 'left', marginBottom: '25px' }}>
            <a href="https://nebraska.kuder.com/landing-page" className={classes.link} target="_blank">
              Nebraska Career Connections
            </a>
          </summary>

          <summary style={{ textAlign: 'left', marginBottom: '25px' }}>
            <a href="https://www.educationquest.org" className={classes.link} target="_blank">
              Education Quest
            </a>
            <aside className={classes.description}>
              Education Quest is a non-profit organization that provides FREE services and programs for Nebraska students and families.
            </aside>
          </summary>
          <summary style={{ textAlign: 'left', marginBottom: '25px' }}>
            <a href="http://www.remilitary.com/article-military-resources-parents-educators.html" className={classes.link} target="_blank">
              Military Resources for Parents, Educations, and Students
            </a>
          </summary>
          <summary style={{ textAlign: 'left', marginBottom: '25px' }}>
            <a href="https://americorps.gov/" className={classes.link} target="_blank">
              AmeriCorps
            </a>
            <aside className={classes.description}>
              AmeriCorps members train volunteers, tutor and mentor at-risk youth, build housing, clean up rivers and streams, help seniors live
              independently, provide emergency and long-term assistance to victims of natural disasters, and meet other community needs.
            </aside>
          </summary>
          <div className={classes.divider}></div>
        </Grid>
      </Grid>
    </Box>
  );
}
